import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrganisationService } from '../../../../../DTO/Organisation/Organisation.service';
import { OrganisationDTO } from '../../../../../DTO/Organisation/OrganisationDTO';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../../../material.module';
import { TablerIconsModule } from 'angular-tabler-icons';
import { LocalizationPipe } from '../../../../../pipe/localization-pipe';
import { LocalizationService } from '../../../../../services/localizationService';
import { PermissionService } from '../../../../../../core/authorization/permission.service';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { MatSnackBar } from '@angular/material/snack-bar';
import {LlmSettingsComponent} from "../../../llm-settings/components/llm-settings/llm-settings.component";
import {
  PromptManagementComponent
} from "../../../prompt-management/components/prompt-management/prompt-management.component";
import {KeycloakMatching} from "../../../keyCloak/keycloak-matching";
import {RoleManagementComponent} from "../../../role-management/role-management/role-management.component";
import {ResourceManagementComponent} from "../../../file/resource-management/resource-management.component";

@Component({
  selector: 'app-organization-detail',
  templateUrl: './organization-detail.component.html',
  styleUrls: ['./organization-detail.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MaterialModule,
    TablerIconsModule,
    LocalizationPipe,
    LlmSettingsComponent,
    PromptManagementComponent,
    KeycloakMatching,
    RoleManagementComponent,
    ResourceManagementComponent,
  ]
})
export class OrganizationDetailComponent implements OnInit {
  @ViewChild('tabGroup') tabGroup: MatTabGroup;
  @ViewChild(LlmSettingsComponent) llmSettingsComponent: LlmSettingsComponent;
  @ViewChild(PromptManagementComponent) promptManagementComponent: PromptManagementComponent;
  @ViewChild(KeycloakMatching) keycloakComponent: KeycloakMatching;

  organization: OrganisationDTO=new OrganisationDTO();
  organizationId: number = 0;
  isLoading: boolean = false;
  error: string = '';
  selectedTab: number = 0;
  authUsersLoaded: boolean = false;
  llmSettingsLoaded: boolean = false;
  promptManagementLoaded: boolean = false;
  keycloakSettingsLoaded: boolean = false;

  // Etiketler için eşleme
  labels = {
    'basicInfo': 'Organization.BasicInfo',
    'owners': 'Organization.Owners',
    'noOwners': 'Organization.NoOwners',
    'detailsTab': 'Organization.DetailsTab',
    'authorizedUsers': 'Organization.AuthorizedUsers',
    'llmSettings': 'Organization.LlmSettings'
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private organisationService: OrganisationService,
    public localizationService: LocalizationService,
    public permissionService: PermissionService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.organizationId = +params['id'];
        this.loadOrganizationDetails();
      }
    });
  }

  loadOrganizationDetails(): void {
    this.isLoading = true;
    this.organisationService.getById(this.organizationId).subscribe(res=>{
      this.isLoading=false;
      if(res["data"]){
        this.organization=new OrganisationDTO();
        this.organization.bindData(res["data"]);
      }
    })
  }

  onTabChange(event: MatTabChangeEvent): void {
    switch (event.index) {
      case 1: // Authorized Users tab
        if (!this.authUsersLoaded &&
            this.organization.id &&
            this.organization.owners.length > 0 &&
            this.permissionService.hasPermission('VIEW_ORGANISATION_AUTHORIZED_USERS')) {
          this.loadAuthorizedUsers();
        }
        break;
      case 2: // LLM Settings tab
        if (!this.llmSettingsLoaded &&
            this.permissionService.hasPermission('LLM_SETTINGS_VIEW')) {
          this.llmSettingsLoaded = true;
          if (this.llmSettingsComponent) {
            this.llmSettingsComponent.loadSettingsData();
          }
        }
        break;
      case 3: // Prompt Management tab
        if (!this.promptManagementLoaded &&
            this.permissionService.hasPermission('PROMPT_MANAGEMENT_VIEW')) {
          this.promptManagementLoaded = true;
          if (this.promptManagementComponent) {
            this.promptManagementComponent.loadPrompts();
          }
        }
        break;
      case 4: // KeyCloak Settings tab
        if (!this.keycloakSettingsLoaded &&
            this.permissionService.hasPermission('KEYCLOK_MANAGEMENT_VIEW')) {
          this.keycloakSettingsLoaded = true;
          if (this.keycloakComponent) {
            this.keycloakComponent.loadKeycloakSettings();
          }
        }
        break;
    }
  }

  loadAuthorizedUsers(): void {
    this.isLoading = true;
    this.organisationService.getOrganisationAuthorizedUsers(this.organization.owners).subscribe(res => {
      if (res["data"] && res["data"].length > 0) {
        for (let i = 0; i < res["data"].length; i++) {
          const userData = res["data"][i];
          const matchingOwner = this.organization.owners.find(owner => owner.userId === userData.userId);
          if (matchingOwner) {
            matchingOwner.email = userData.email;
            matchingOwner.firstName = userData.firstName;
            matchingOwner.lastName = userData.lastName;
          }
        }
      }
      this.authUsersLoaded = true;
      this.isLoading = false;

      this.selectedTab = 1;
    }, error => {
      console.error('Error loading authorized users', error);
      this.error = this.localizationService.getLocalizationValue('Organization.Messages.AuthorizedUsersError');
      this.isLoading = false;
      this.selectedTab = 1;
    });
  }

  goBack(): void {
    this.router.navigate(['/apps/organization']);
  }

  onSettingsSaved(): void {
    this.snackBar.open(
      this.localizationService.getLocalizationValue('LlmSettings.SettingsSavedSuccess'),
      this.localizationService.getLocalizationValue('Common.Ok'),
      { duration: 3000 }
    );
  }

  protected readonly window = window;
}
